export const dealsData = [
  {
    id: 1,
    dealName: "AI Collaboration",
    relatedContact: "John Doe",
    customer_company: "Google",
    dealType: "New",
    dealValue: "5000",
    dealStatus: "Qualify To Buy",
    vat: "5",
    relatedProject: "Voice Assistant",
    owner: "Theresa",
    customer_tag: "Collab",
    closeDate: "10 Oct 2023",
    createdDate: "05 Sep 2023, 12:00 pm",
    source: "Referral",
    probability: "80%",
    status: "Open",
    key: "1",
    lastContacted:'21 Oct 2024, 12:00 pm',
    email:'abc@xyz.com',
    phone:"9876543210",
  },
  {
    id: 2,
    dealName: "Cloud Integration",
    relatedContact: "Jane Smith",
    customer_company: "Amazon",
    dealType: "Renewal",
    dealValue: "7500",
    dealStatus: "Proposal Sent",
    vat: "5",
    relatedProject: "Cloud Storage",
    owner: "Jami",
    customer_tag: "Promotion",
    closeDate: "15 Oct 2023",
    createdDate: "07 Sep 2023, 03:22 pm",
    source: "Email Campaign",
    probability: "65%",
    status: "Won",
    key: "2",
    lastContacted:'21 Oct 2024, 12:00 pm',
    email:'abc@xyz.com',
    phone:"9876543210",
  },
  {
    id: 3,
    dealName: "Blockchain Partnership",
    relatedContact: "Michael Scott",
    customer_company: "Microsoft",
    dealType: "New",
    dealValue: "6000",
    dealStatus: "Negotiation",
    vat: "5",
    relatedProject: "Blockchain Dev",
    owner: "Jami",
    customer_tag: "Rated",
    closeDate: "20 Oct 2023",
    createdDate: "12 Sep 2023, 10:15 am",
    source: "LinkedIn",
    probability: "90%",
    status: "Won",
    key: "3",
    lastContacted:'21 Oct 2024, 12:00 pm',
    email:'abc@xyz.com',
    phone:"9876543210",
  },
  {
    id: 4,
    dealName: "Enterprise Software Deal",
    relatedContact: "Dwight Schrute",
    customer_company: "Meta",
    dealType: "Upgrade",
    dealValue: "8200",
    dealStatus: "Closed",
    vat: "5",
    relatedProject: "Software Upgrade",
    owner: "Theresa",
    customer_tag: "Collab",
    closeDate: "25 Sep 2023",
    createdDate: "01 Sep 2023, 01:22 pm",
    source: "Cold Call",
    probability: "95%",
    status: "Won",
    key: "4",
    lastContacted:'21 Oct 2024, 12:00 pm',
    email:'abc@xyz.com',
    phone:"9876543210",
  },
  {
    id: 5,
    dealName: "AI Integration",
    relatedContact: "Sarah Connor",
    customer_company: "Nvidia",
    dealType: "New",
    dealValue: "9800",
    dealStatus: "Proposal Sent",
    vat: "5",
    relatedProject: "AI Chip",
    owner: "Jami",
    customer_tag: "Collab",
    closeDate: "05 Nov 2023",
    createdDate: "20 Sep 2023, 09:00 am",
    source: "Website Inquiry",
    probability: "70%",
    status: "Open",
    key: "5",
    lastContacted:'21 Oct 2024, 12:00 pm',
    email:'abc@xyz.com',
    phone:"9876543210",
  },
  {
    id: 6,
    dealName: "Cybersecurity Package",
    relatedContact: "Neo Anderson",
    customer_company: "Cisco",
    dealType: "New",
    dealValue: "4000",
    dealStatus: "Qualify To Buy",
    vat: "5",
    relatedProject: "Firewall Security",
    owner: "Jerald",
    customer_tag: "Rejected",
    closeDate: "30 Oct 2023",
    createdDate: "01 Sep 2023, 11:30 am",
    source: "Webinar",
    probability: "50%",
    status: "Lost",
    key: "6",
    lastContacted:'21 Oct 2024, 12:00 pm',
    email:'abc@xyz.com',
    phone:"9876543210",
  },
  {
    id: 7,
    dealName: "IoT Solution",
    relatedContact: "Trinity Ward",
    customer_company: "Tesla",
    dealType: "Upgrade",
    dealValue: "12000",
    dealStatus: "Proposal Sent",
    vat: "5",
    relatedProject: "Smart Grid",
    owner: "Theresa",
    customer_tag: "Promotion",
    closeDate: "12 Nov 2023",
    createdDate: "14 Sep 2023, 02:45 pm",
    source: "Referral",
    probability: "85%",
    status: "Won",
    key: "7",
    lastContacted:'21 Oct 2024, 12:00 pm',
    email:'abc@xyz.com',
    phone:"9876543210",
  },
  {
    id: 8,
    dealName: "SaaS Platform Deal",
    relatedContact: "Morpheus Black",
    customer_company: "Salesforce",
    dealType: "New",
    dealValue: "6300",
    dealStatus: "Negotiation",
    vat: "5",
    relatedProject: "Cloud CRM",
    owner: "Jerald",
    customer_tag: "Rated",
    closeDate: "18 Oct 2023",
    createdDate: "15 Sep 2023, 04:10 pm",
    source: "LinkedIn",
    probability: "75%",
    status: "Open",
    key: "8",
    lastContacted:'21 Oct 2024, 12:00 pm',
    email:'abc@xyz.com',
    phone:"9876543210",
  },
  {
    id: 9,
    dealName: "VR Expansion",
    relatedContact: "John Wick",
    customer_company: "Facebook",
    dealType: "Renewal",
    dealValue: "9500",
    dealStatus: "Closed",
    vat: "5",
    relatedProject: "Oculus VR",
    owner: "Guillory",
    customer_tag: "Collab",
    closeDate: "07 Nov 2023",
    createdDate: "20 Sep 2023, 01:00 pm",
    source: "Cold Call",
    probability: "95%",
    status: "Won",
    key: "9",
    lastContacted:'21 Oct 2024, 12:00 pm',
    email:'abc@xyz.com',
    phone:"9876543210",
  },
  {
    id: 10,
    dealName: "Big Data Partnership",
    relatedContact: "Walter White",
    customer_company: "IBM",
    dealType: "New",
    dealValue: "11000",
    dealStatus: "Negotiation",
    vat: "5",
    relatedProject: "Data Analytics",
    owner: "Guillory",
    customer_tag: "Collab",
    closeDate: "22 Oct 2023",
    createdDate: "22 Sep 2023, 10:00 am",
    source: "Conference",
    probability: "88%",
    status: "Won",
    key: "10",
    lastContacted:'21 Oct 2024, 12:00 pm',
    email:'abc@xyz.com',
    phone:"9876543210",
  }
];